// src/App.jsx
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { ConfirmProvider } from './hooks/useConfirm'; // ← ADD THIS
import DashboardLayout from './components/layout/DashboardLayout';

// Pages...
import Login from './pages/auth/Login';
import Register from './pages/auth/Register';
import CustomerDashboard from './pages/dashboard/customer/Dashboard';
import Nannies from './pages/dashboard/customer/Nannies';
import CurrentContract from './pages/dashboard/customer/contracts/CurrentContract';
import Messages from './pages/dashboard/shared/Messages'; // ← NEW

import NannyDashboard from './pages/dashboard/nanny/Dashboard';
import ProfileCompletion from './pages/dashboard/nanny/ProfileCompletion';
import NannyCurrentContract from './pages/dashboard/nanny/contracts/CurrentContract';

import AgentDashboard from './pages/dashboard/agent/Dashboard';
import AgentNanniesList from './pages/dashboard/agent/nannies/List';

import AdminDashboard from './pages/dashboard/admin/Dashboard';
import NannyOffers from './pages/dashboard/nanny/offers/NannyOffers';
import CustomerOffers from './pages/dashboard/customer/offers/CustomerOffer';
import Reviews from './pages/dashboard/shared/Reviews';
import ProfileUpdate from './pages/dashboard/shared/ProfileUpdate';
import Profile from './pages/dashboard/shared/Profile';
import Disputes from './pages/dashboard/shared/Disputes';
import Support from './pages/dashboard/shared/Support';
import CreateAdmin from './pages/dashboard/admin/admins/CreateAdmin';
import AdminPolicies from './pages/dashboard/admin/settings/AppSettings';
import AdminComplaints from './pages/dashboard/admin/complaints/Complaints';
import AdminDisputes from './pages/dashboard/admin/disputes/Disputes';
import AdminUsers from './pages/dashboard/admin/users/Users';
import AppSettings from './pages/dashboard/admin/settings/AppSettings';
import LandingPage from './pages/LandingPage';
import TermsPage from './pages/TermsPage';
import PrivacyPolicyPage from './pages/PrivacyPolicyPage';
import Resources from './pages/dashboard/shared/Resources';
import AdminResources from './pages/dashboard/admin/Resources';
import ResourceDetail from './pages/dashboard/shared/ResourceDetail';
import ResourceForm from './pages/dashboard/admin/ResourceForm';

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <ConfirmProvider> {/* ← WRAPS EVERYTHING */}
          <Routes>
            <Route path="/" element={<LandingPage />} />
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/terms" element={<TermsPage />} />
            <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />



            <Route path="/dashboard" element={<DashboardLayout />}>
              <Route index element={<Navigate to="/dashboard/customer" replace />} />
              <Route path="/dashboard/resources" element={<Resources />} />
              <Route path="/dashboard/resources/:id" element={<ResourceDetail />} />
              <Route path="/dashboard/admin/resources" element={<AdminResources />} />
              <Route path="/dashboard/admin/resources/create" element={<ResourceForm />} />
              <Route path="/dashboard/admin/resources/:id/edit" element={<ResourceForm />} />

              {/* Customer */}
              <Route path="customer" element={<CustomerDashboard />} />
              <Route path="customer/nannies" element={<Nannies />} />
              <Route path="customer/offers" element={<CustomerOffers />} />
              <Route path="customer/contract/current" element={<CurrentContract />} />
              <Route path="customer/messages" element={<Messages />} />

              {/* Nanny */}
              <Route path="nanny" element={<NannyDashboard />} />
              <Route path="nanny/profile" element={<ProfileCompletion />} />
              <Route path="nanny/offers" element={<NannyOffers />} />
              <Route path="nanny/contract/current" element={<NannyCurrentContract />} />
              <Route path="messages" element={<Messages />} />
              <Route path="reviews" element={<Reviews />} />
              <Route path="profile/:id?" element={<Profile />} />
              <Route path="support" element={<Support />} />
    
              {/* Agent & Admin */}
              <Route path="agent" element={<AgentDashboard />} />
              <Route path="agent/nannies" element={<AgentNanniesList />} />
              <Route path="admin" element={<AdminDashboard />} />
              <Route path="admin/users" element={<AdminUsers />} />
              <Route path="admin/disputes" element={<AdminDisputes />} />
              <Route path="admin/complaints" element={<AdminComplaints />} />
              <Route path="admin/app-settings" element={<AppSettings />} />
              <Route path="admin/create-admin" element={<CreateAdmin />} />
              
            </Route>

            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </ConfirmProvider>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;